import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { normalizeSocialLink as m } from "../../utils/normalize-social-link.mjs";
import { getSocialLinkIcon as i } from "../../utils/get-social-link-icon.mjs";
import d from "../../../components/store-image.mjs";
import { useStore as s } from "../../../store/index.mjs";
import { S3_BUCKET_URL as c } from "../../../constants/s3-bucket-url.mjs";
import { StoreImageEnum as g } from "../../../enums/store-image-enum.mjs";
const E = ({ profile: r, socialLinks: l }) => {
  var n;
  const { locale: t } = s();
  return /* @__PURE__ */ o(
    "section",
    {
      role: "region",
      "aria-labelledby": "region-heading",
      style: {
        backgroundImage: `linear-gradient(to top, rgba(5, 0, 33, 1) 0%, rgba(6, 1, 36, 0.64) 100%),
          url(${c}/images/profile-background/urban-profile-background.jpeg)`
      },
      className: "flex min-h-[500px] w-full flex-col items-center justify-center gap-20 bg-cover bg-center px-5 py-12 sm:max-w-xl sm:rounded-lg",
      children: [
        /* @__PURE__ */ e("div", { className: "border-3 border-THEME-secondary rounded-full", children: /* @__PURE__ */ e(
          d,
          {
            className: "rounded-full border-0 border-transparent",
            width: 149,
            height: 149,
            alt: r.sellerName,
            imageType: g.profile,
            src: (n = r.sellerPhoto) == null ? void 0 : n.path
          }
        ) }),
        /* @__PURE__ */ o("div", { className: "flex flex-col items-center", children: [
          /* @__PURE__ */ e(
            "h1",
            {
              id: "region-heading",
              lang: t,
              className: "text-THEME-primary mb-2 break-all text-center text-[40px] font-bold leading-[50.4px]",
              children: r.sellerName
            }
          ),
          /* @__PURE__ */ e(
            "span",
            {
              lang: t,
              className: "text-THEME-secondary hyphens-auto mb-4 text-center text-lg font-normal",
              children: r.bio
            }
          ),
          !!l.length && /* @__PURE__ */ e("div", { className: "z-1 flex flex-wrap items-center justify-center gap-1.5", children: l.map((a) => /* @__PURE__ */ e(
            "a",
            {
              href: m(a),
              target: "_blank",
              rel: "noreferrer",
              className: "rounded-md p-1",
              "aria-label": a.type,
              children: i(a.type, "fill-THEME-secondary")
            },
            a.type
          )) })
        ] })
      ]
    }
  );
};
export {
  E as ProfileUrban
};
